import React, { useCallback } from "react";
import { connect } from "react-redux";

import Checkbox from "antd/es/checkbox";
import cn from "classnames";
import { useIntl } from "react-intl";

import { Lead } from "@mapmycustomers/shared/types/entity";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Button } from "@mapmycustomers/ui";

import { hideLeads, showHiddenLeads } from "@app/component/leadFinder/store/actions";

import styles from "./MoreOptions.module.scss";

interface Props {
  className?: string;
  onHide?: () => void;
  onHideLead: typeof hideLeads.request;
  onShowLead: typeof showHiddenLeads.request;
  primaryRecord: Lead;
}

const MoreOptions = ({ className, onHide, onHideLead, onShowLead, primaryRecord }: Props) => {
  const intl = useIntl();

  const [hideLead, , , toggleHideLead] = useBoolean(primaryRecord.blackListed);

  const handleSave = useCallback(() => {
    (hideLead ? onHideLead : onShowLead)({ placeIds: [primaryRecord.place_id] });
    onHide?.();
  }, [onHide, hideLead, onHideLead, onShowLead, primaryRecord]);

  return (
    <div className={cn(styles.moreOptionsContainer, className)}>
      <div className={styles.moreOptions}>
        <Checkbox checked={hideLead} onChange={toggleHideLead}>
          {intl.formatMessage({
            id: "map.tool.leadFinder.duplicate.modal.moreOptions.hideLead",
            defaultMessage: "Hide Lead",
            description: "Hide Lead checkbox",
          })}
        </Checkbox>
        <Button
          disabled={primaryRecord.blackListed === hideLead}
          onClick={handleSave}
          type="primary"
        >
          {intl.formatMessage({
            id: "map.tool.leadFinder.duplicate.modal.moreOptions.button.save",
            defaultMessage: "Save",
            description: "Save button",
          })}
        </Button>
      </div>
      <div>
        <span>
          {intl.formatMessage({
            id: "map.tool.leadFinder.duplicate.modal.moreOptions.description",
            defaultMessage:
              "If you know a lead will never be a good fit, you can hide the result. Hidden results can always be toggled into view as needed via Lead Finder Settings.",
            description: "Hide duplicates helper text",
          })}
        </span>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  onHideLead: hideLeads.request,
  onShowLead: showHiddenLeads.request,
};

export default connect(null, mapDispatchToProps)(MoreOptions);
